import { toRefs, watch } from 'vue';
import Item from './component-lib.esm3.js';
import Divider from '../divider/component-lib.esm.js';
import ListItemTitle from '../list/component-lib.esm4.js';
import ListItemAction from '../list/component-lib.esm6.js';
import Checkbox from '../../forms/checkbox/component-lib.esm.js';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import FlexSpacer from '../flex-spacer/component-lib.esm.js';
import uniqueId from 'lodash/uniqueId';
import { useModel } from '../../compositions/component-lib.esm13.js';

//
var script = {
  name: 'ItemAccordion',
  components: {
    Item,
    Divider,
    ListItemAction,
    ListItemTitle,
    Checkbox,
    ChevronIcon,
    FlexSpacer
  },
  props: {
    ...Item.props,
    active: Boolean,
    open: Boolean
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      active,
      open
    } = toRefs(props);
    const inputId = uniqueId('item-accordion-');
    const isOpen = useModel(open, val => emit('update:open', val));
    const isActive = useModel(active, val => emit('update:active', val));
    watch(isActive, val => {
      if (val) isOpen.value = true;else isOpen.value = false;
    });
    function handleClick() {
      isActive.value = !isActive.value;
    }
    return {
      inputId,
      isOpen,
      isActive,
      handleClick
    };
  }
};
export { script as default };